import { graphql } from 'gql/generated'

export const CREATE_OPERATIONAL_COST = graphql(`
  mutation CreateOperationalCost($input: CreateOperationalCostInput!) {
    createOperationalCost(input: $input) {
      id
      isNew
    }
  }
`)

export const CHANGE_OPERATIONAL_COST_SETTINGS = graphql(`
  mutation ChangeOperationalCostSettings($input: ChangeOperationalCostSettingsInput!) {
    changeOperationalCostSettings(input: $input)
  }
`)

export const UPLOAD_OPERATIONAL_COST_SETTINGS = graphql(`
  mutation UploadOperationalCostSettings($input: UploadOperationalCostSettingsInput!) {
    uploadOperationalCostSettings(input: $input)
  }
`)
